<div class="max-height data-monitor-container">
  <!-- 項目選択 -->
  <div v-show="showSelect">
    <data-monitor-select ref="data_monitor_select" :isUseCache="isUseCache" :isDataMonitor="isDataMonitor"
      :isSpecial="isSpecial" :dataMonitorFunctionSettings="dataMonitorFunctionSettings" :selectedAtFunc="selectedAtFunc"
      :isHev="isHev" :atInfo="atInfo" @start-execute="startExecute" @display-processing="displayProcessing" />
  </div>
  <!-- 計測 -->
  <wrapped-teleport :destinationId="modalContentId" :noRenderTeleport="!modalContentId || showSelect"
    :disabled="!showModal">
    <div v-if="!unmountMeasure && !showSelect" style="height: 100%;">
      <div :class="getAreaStyle()">
        <data-monitor-execute class="data-monitor" ref="data_monitor_execute" :inExecution="inExecution"
          :inPlaying="inPlaying" :conversionList="conversionList" :dataMonitorList="dataMonitorList"
          :selectedFunctionList="selectedFuncs" :selectedFunctionHash="selectedFunctionHash"
          :graphConfigInfo="graphConfigInfo" :completeResolve="completeResolve" :baseOrgTime="baseTime"
          :baseTimeOffset="baseTimeOffset" :measurementUuid="measurementUuid" :apiToken="apiToken" :endpoint="endpoint"
          :highlightItems="highlightItems" :funcValues="funcValues" :specifiedSystemId="specifiedSystemId"
          :dataMonitorFunctionSettings="dataMonitorFunctionSettings" :savedMarkerInfo="markerInfo"
          :isCompleted="isCompleted" :showModal="showModal" :graphSettingsDestinationId="graphSettingsDestinationId"
          :selectedAtFunc="selectedAtFunc" :hevAtMenuTitleKey="hevAtMenuTitleKey" :isHev="isHev" :atInfo="atInfo"
          :isActiveTestDriving="isActiveTestDriving" :isOnlyCsvExport="isOnlyCsvExport" :isTestMode="isTestMode"
          @data-total-count="notifyDataTotalCount" @toggle-playing="togglePlaying"
          @change-selected-funcs="changeSelectedFuncs" @show-disconnected-server-error="showCommonError"
          @back-select="backSelect" @stop-monitor="execStopMonitor" @start-monitor="startMonitor"
          @set-graph-config="setGraphConfig" @change-check-value="changeCheckValue" @change-no-signal="changeNoSignal"
          @current-tab-changed="currentTabChanged" @zoom-pan-state-changed="zoomPanStateChanged"
          @measure-component-mounted="measureMountedEvent" />
      </div>
    </div>
  </wrapped-teleport>
  <processing-view :processing="isDisplayProcessing" />
</div>